import { getSetStore, getStoreValue } from "@/hooks/useStore";
import { LoginInfoState } from "@/store/globalStore";
import { isFalse, throttle } from "@/utils";
import globalConst from "@/utils/global";
import { saveHttpError } from "@/utils/http-error";
import { Modal, notification } from "antd";
import { equals, forEachObjIndexed, has, keys, mergeRight, reduce } from "ramda";
import type { RequestOptionsInit } from "umi-request";
import { extend } from "umi-request";
function toLine(name: string) {
  return name.replace(/([A-Z])/g, "_$1").toLowerCase();
}
function isString(arg: any): arg is string {
  return typeof arg === "string";
}
type ObjectMap<Key extends string | number | symbol = any, Value = any> = {
  [key in Key]: Value;
};
function trim(str: any) {
  return isString(str) ? str.trim() : str;
}
function set(key: string, value: string, searchParams: URLSearchParams) {
  value = trim(value);
  if (isFalse(value)) {
    return;
  }
  searchParams.set(key, value);
}
function getHeaders(isUpload: boolean): HeadersInit {
  return isUpload
    ? {
        Accept: "*/*",
      }
    : {
        Accept: "*/*",
        "Content-Type": "application/json",
        //	accessToken: reduxState.state ? reduxState.state.global.accessToken : '' //localStorage.getItem('rantionCrmAccessToken') || ''
      };
}
const request = extend({
  useCache: true,
  ttl: 1000,
  maxCache: 0,
  paramsSerializer: (params: ObjectMap) => {
    const searchParams = reduce(
      (searchParams, key) => {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((res, index) => {
            if (typeof res === "object") {
              forEachObjIndexed((value2, key2) => {
                if (key === "orders" && typeof value2 === "string") {
                  value2 = toLine(value2);
                }
                set(`${key}[${index}].${String(key2)}`, value2, searchParams);
              }, res);
            } else {
              set(`${key}[${index}]`, res, searchParams);
            }
          });
        } else {
          set(key, value, searchParams);
        }
        return searchParams;
      },
      new URLSearchParams(),
      keys(params),
    );
    return searchParams.toString();
  },
  errorHandler: function (error) {
    let msg = "";
    if (error.response) {
      msg = error.response.statusText;
    } else {
      msg = error.message;
    }
    if (equals(error.name, "AbortError") || equals(error.type, "AbortError")) {
      return { data: null, msg, code: "20", success: false };
    }
    return { data: null, msg, code: "-1", success: false };
  },
});
function requestInterceptors(url: string, options: RequestOptionsInit = {}) {
  const defaultHeaders = getHeaders(options.data instanceof FormData);
  const headers = mergeRight(defaultHeaders, options.headers ?? {}) as HeadersInit;
  const accessToken = options.noToken ? undefined : getStoreValue(LoginInfoState).accessToken; // localStorage.getItem('rantion-erp-accessToken')
  return {
    url: url.startsWith("http") || options.noPrefix ? url : `${globalConst.serverUrl}${url}`,
    options: isFalse(accessToken)
      ? options
      : mergeRight(options, { headers: { ...headers, accessToken } }),
  };
}

export default <T = any>(url: string, options: RequestOptionsInit = {}) => {
  const interceptorsResponse = requestInterceptors(url, options);
  return request<T>(interceptorsResponse.url, interceptorsResponse.options);
};
const notificationError = throttle(notification.error);
const successCode = ["0X0000", "200"];
function notLogin() {
  getSetStore(LoginInfoState)(() => ({}));
  Modal.confirm({
    title: "登录失效，是否跳转登录",
    onOk() {
      const redirect = location.pathname + "" + location.search;
      location.href = "/login?redirect_uri=" + encodeURIComponent(redirect);
    },
  });
}
export function updateResponse<T = any, P extends Promise<any> = any>(data: P) {
  return data.then((data: Rantion.AjaxData<T>) => {
    if (has("response", data) && data.response.status === 200) {
      return data;
    }
    if (successCode.includes(data.code)) {
      return data;
    }
    switch (data.code) {
      case "401":
        notLogin();
        break;
      case "200":
        break;
      case "20":
        console.log("请求中断");
        // notification.info({
        // 	message: '请求关闭'
        // })
        break;
      case "0X0000":
        break;
      default:
        notificationError({
          message: "请求异常",
          description: data.msg || "未知异常",
        });
        data.success = false;
        break;
    }
    try {
      if (!["200", "0X0000"].includes(data.code)) {
        // 异常  存储到本地
        saveHttpError(data);
      }
    } catch (error) {
      console.log(error);
    }
    return data;
  });
}
